export default __webpack_public_path__ + "media/projects/purple3-thumb-10c0dc56.svg";